var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90039 10C9.97146 10 11.6504 8.32107 11.6504 6.25C11.6504 4.17893 9.97146 2.5 7.90039 2.5C5.82932 2.5 4.15039 4.17893 4.15039 6.25C4.15039 8.32107 5.82932 10 7.90039 10Z",
    fill: "#4A72FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65039 17.5C1.65039 17.5 0.400391 17.5 0.400391 16.25C0.400391 15 1.65039 11.25 7.90039 11.25C14.1504 11.25 15.4004 15 15.4004 16.25C15.4004 17.5 14.1504 17.5 14.1504 17.5H1.65039Z",
    fill: "#4A72FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1504 4.375C14.1504 4.02982 14.4302 3.75 14.7754 3.75H19.7754C20.1206 3.75 20.4004 4.02982 20.4004 4.375C20.4004 4.72018 20.1206 5 19.7754 5H14.7754C14.4302 5 14.1504 4.72018 14.1504 4.375Z",
    fill: "#4A72FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7754 7.5C14.4302 7.5 14.1504 7.77982 14.1504 8.125C14.1504 8.47018 14.4302 8.75 14.7754 8.75H19.7754C20.1206 8.75 20.4004 8.47018 20.4004 8.125C20.4004 7.77982 20.1206 7.5 19.7754 7.5H14.7754Z",
    fill: "#4A72FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2754 11.25C16.9302 11.25 16.6504 11.5298 16.6504 11.875C16.6504 12.2202 16.9302 12.5 17.2754 12.5H19.7754C20.1206 12.5 20.4004 12.2202 20.4004 11.875C20.4004 11.5298 20.1206 11.25 19.7754 11.25H17.2754Z",
    fill: "#4A72FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2754 15C16.9302 15 16.6504 15.2798 16.6504 15.625C16.6504 15.9702 16.9302 16.25 17.2754 16.25H19.7754C20.1206 16.25 20.4004 15.9702 20.4004 15.625C20.4004 15.2798 20.1206 15 19.7754 15H17.2754Z",
    fill: "#4A72FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEmployee);
export default __webpack_public_path__ + "static/media/active-employee.1f9b13d250021c1927013b082ec06144.svg";
export { ForwardRef as ReactComponent };